import { IncentivesTaxe } from './incentives-taxe.model';

export class EnergyIncentivesTax {
	incomeTax: number;
	electric: IncentivesTaxe;
	diesel: IncentivesTaxe;
	gas: IncentivesTaxe;
	electricComp: IncentivesTaxe;
	taxReductLimitDate:Date;
}
